
<template>
  <div>
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 类别 -->

        <el-col :span="12">
          <el-form-item
            prop="leibieDictId"
            label="类别"
          >
            <Combox
              v-model="entityData.leibieDictId"
              :disabled="true"
              type-id="D82"
              :option-data="getComboxData('D82')"
              :add-client="false"
            />
          </el-form-item>
        </el-col>

        <!-- 主要用途 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuYaoYongTu"
            label="主要用途"
          >
            <el-input
              v-model="entityData.zhuYaoYongTu"
              clearable
              size="small"
            />
          </el-form-item>
        </el-col>

        <!-- 版本号 -->

        <el-col :span="12">
          <el-form-item
            prop="banBen"
            label="版本"
          >
            <el-input
              v-model="entityData.banBen"
              disabled
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 更新内容 -->
        <el-col :span="12">
          <el-form-item
            prop="gengXinNeiRong"
            label="更新内容"
          >
            <el-input
              v-model="entityData.gengXinNeiRong"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 已用于 -->
        <el-col :span="12">
          <el-form-item
            prop="usedTo"
            label="已用于"
          >
            <el-input
              v-model="entityData.usedTo"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 使用时间 -->
        <el-col :span="12">
          <el-form-item
            prop="usedDate"
            label="使用时间"
          >
            <el-date-picker
              v-model="entityData.usedDate"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 简介内容 -->
        <el-col :span="24">
          <el-form-item
            prop="jianJieNeiRong"
            label="简介内容"
          >
            <el-input
              v-model="entityData.jianJieNeiRong"
              type="textarea"
              :rows="5"
              clearable
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保  存
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
export default {
  components: {
    Combox
  },
  props: {
    // postId: { type: Number, default: null }
  },
  data() {
    return {
      entityId: null,
      entityData: {},
      allComboxData: [],
      rules: {
        banBen: [{ required: true, message: '请输入主要用途', trigger: 'change,blur' }],
        zhuYaoYongTu: [{ required: true, message: '请输入主要用途', trigger: 'change,blur' }],
        leibieDictId: [{ required: true, message: '请输入主要用途', trigger: 'change,blur' }]
      },
      selectedValue: []
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D82').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    init() {
      this.entityId = this.$route.params.id
      if (!this.entityId) {
        this.$router.go(-1)
        return
      }
      const path = '/api/services/app/GR05/GetEditGR05?Id=' + this.entityId
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/GR05/CreateOrUpdateGR05'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
